import React from 'react';

import RelatedWorkServices from '../../krDetails/related_work/services';
import {KeyDownEvent} from "../../../utils/eventKey"
import { useTranslation } from 'react-i18next';

export default function addNew({
  type,
  addNewItem,
  handleFocusLock,
}) {
  const { t } = useTranslation();
  const openNewAiPopup = () => {
    $('#app-portal-container').css('z-index', 18);
    var tmpUrl = aiDetailsV1Url + "/?id=-1&dummyAi=yes";
    openFullPopUp(aiFullViewPopUp, tmpUrl, this);

    // Need to continually check for the AI page to load to set event listeners
    const checkForCreateAiModalLoad = setInterval(() => {
      const exitPopup = document.getElementById("ai-details-close");
      // If the exit button exists, wait for the click event to get
      // all the details of the AI.
      if (exitPopup) {
        const getDataOnClick = () => {
          // If the dummy text still exists, the AI hasn't been saved.
          if (document.querySelector(".dummy-text")) {
            document.getElementById("aiEdit").innerHTML = "";
            setTimeout(() => handleFocusLock(false), 100);
            return;
          }
          const description = document.querySelector(".aiEditPageTitle").innerHTML;
          const tagName = document.querySelector('.wsNameAI').title;
          const ownerName = document.querySelector('.assigneeAI').dataset.assignAi;
          const rag = document.querySelector(".ragClickDiv").dataset.value;
          const dueDate = document.querySelector("#ai-due-date-option").innerHTML;
          // Due date is in date form, need to convert it to epoch form
          const due_date = new Date(dueDate).valueOf() / 1000;
          const state = document.querySelector(".statusImg").dataset.value;
          const priority = document.querySelector(".priorityImg").dataset.value;
          addNewItem([{
            id: aiId === undefined ? null : aiId,
            description,
            tagName,
            ownerName,
            due_date,
            rag,
            state,
            priority,
            viewPermissions: true
          }]);
          exitPopup.removeEventListener('click', getDataOnClick);
          // Have to remove the form... for some reason the event listener
          // isn't getting refreshed on another load of the popup.
          document.getElementById("aiEdit").innerHTML = "";
        }

        clearInterval(checkForCreateAiModalLoad);
        exitPopup.addEventListener("click", getDataOnClick);
      }
    }, 50);
  }

  const openNewWorkstreamPopup = () => {
    $('#app-portal-container').css('z-index', 100);
    
    new RelatedWorkServices().getCreateWorkstreamForm()
      .then(newWorkstreamForm => {
        const receiveMessage = (event) => {
          if (event.origin !== window.location.origin ||
              !event.data ||
              event.data.source !== "related-work"
          ) {
            return;
          }
          const data = event.data.data;
          // Format data for correct keys
          const formattedData = Object.values(data).map(datum => {
            return {
              progress: "0",
              progress_color: "#476C89",
              target_date: null,
              viewPermissions: true,
              name: datum.wsName,
              ...datum
            }
          })
          addNewItem(formattedData);
          
          window.removeEventListener("message", receiveMessage);
        };
        
        window.addEventListener("message", receiveMessage);
        openCreateWsDialog(newWorkstreamForm.data);
        const exitPopup = document.getElementById("addWsCancel");
        if (exitPopup) {
          const getDataOnClick = () => {
            setTimeout(() => handleFocusLock(false), 100);
            return;
          }
          exitPopup.removeEventListener('click', getDataOnClick);
        }
        exitPopup.addEventListener("click", getDataOnClick);
      });
  }

  const clickHandler = (e) => {
    e.stopPropagation();
    handleFocusLock(true);
    if (type === "ai") {
      openNewAiPopup();
    } else if (type === "workstream") {
      openNewWorkstreamPopup();
    } else {
    return () => {};
    }
  }

  return (
    <div className="add-new-item"
      id="add-new-item-btn"
      onClick={clickHandler}
      role="button"
      tabIndex={0}
			onKeyDown={(e) => KeyDownEvent(e, () => clickHandler(e))}
    >
      {type === "ai" && `+ ${t("Create new action item")}`}
      {type === "workstream" && `+ ${t("Create new workstream")}`}
    </div>
  )
}